// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"Chart_canvasContainer__oafGb"};